import { useUserStore } from '@modules/user/stores/user.store' /**

 * Optimistically updates lastUsedWorkspaceId on the current user's regional identity.
 */
export function setLastUsedWorkspaceIdOnCurrentUser(lastUsedWorkspaceId: string): void {
  const { currentUser, setCurrentUser } = useUserStore.getState()
  if (!currentUser?.regionalIdentity) {
    return
  }

  setCurrentUser({
    ...currentUser,
    regionalIdentity: {
      ...currentUser.regionalIdentity,
      lastUsedWorkspaceId,
    },
  })
}
